// polyfill sendBeacon
import './sendbeacon-polyfill';

const BUFFER_LIMIT = 200;

export default ({ host, debounceInterval = 3000 }) => {
  const metricsEndpoint = `${host}/v1/send`;

  let buffer = [];

  const debounce = (fn, time) => {
    let timeout;

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(fn, time);
    };
  };

  const sendBeacon = () => {
    const data = buffer.join('\n');

    buffer = [];

    if (data) {
      navigator.sendBeacon(metricsEndpoint, data);
    }
  };

  const debouncedSendBeacon = debounce(sendBeacon, debounceInterval);

  const trackEvent = event => {
    buffer.push(event);

    if (buffer.length >= BUFFER_LIMIT) {
      console.error('Metrics buffer limit hit. Clearing queue immediately'); // eslint-disable-line
      sendBeacon();
    } else {
      debouncedSendBeacon();
    }
  };

  const serializeEvent = (path, value, type, tags) =>
    `${path}:${value}|${type}|#${tags.join(',')}`;

  const count = (path, tags = [], increment) => {
    trackEvent(serializeEvent(path, increment || 1, 'c', tags));
  };

  const timing = (path, duration, tags = []) => {
    trackEvent(serializeEvent(path, duration, 'ms', tags));
  };

  const distribution = (path, duration, tags = []) => {
    trackEvent(serializeEvent(path, duration, 'd', tags));
  };

  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('unload', sendBeacon, false);
  }

  return {
    count,
    timing,
    gauge: timing,
    flush: sendBeacon,
    distribution,
  };
};



// WEBPACK FOOTER //
// ./src/providers/browser-client.js